export default import.meta.ROLLUP_FILE_URL_rUkiH63qcJGEQEedyX41xw;